import { Component, EventEmitter, Output, ViewChild, Input } from '@angular/core';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: false
})
export class ConfirmationModalComponent {
  @ViewChild('modalRef') modalComponent: ModalComponent;
  @Output() confirmClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  @Input() dialogTitle: string;
  @Input() dialogMessage: string;
  @Input() confirmButtonText: string = 'Confirm';

  open(): void {
    this.modalComponent?.open();
  }

  close(): void {
    this.modalComponent?.close();
  }

  confirm(): void {
    this.confirmClicked.emit();
    this.close();
  }

  cancel(): void {
    this.cancelClicked.emit();
    this.close();
  }
}
